import useDebounce from '@/platform/hooks/useDebounce';
import {
    Button,
    Input,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import axios from 'axios';
import { useEffect, useState } from 'react';

const KVKSearchModal = ({ open, onClose, onChange }) => {
    const [kvk, setKvk] = useState('');
    const [results, setResults] = useState([]);

    const debouncedKvk = useDebounce(kvk);

    useEffect(() => {
        if (!(debouncedKvk?.length > 1)) {
            setResults([]);

            return;
        }

        const controller = new AbortController();

        axios
            .get('/api/ovio/search-kvk', {
                params: { search: debouncedKvk },
                signal: controller.signal,
            })
            .then(response => setResults(response?.data || []))
            .catch(error => {
                if (!axios.isCancel(error)) {
                    setResults([]);
                }
            });

        return () => controller.abort();
    }, [debouncedKvk]);

    return (
        <Modal open={open} onClose={onClose}>
            <ModalHeader>Zoeken in KvK</ModalHeader>
            <ModalContent>
                <div className='mb-4'>
                    <Input
                        placeholder='Zoeken op bedrijfsnaam of KvK nummer'
                        value={kvk}
                        onChange={event => setKvk(event.target.value)}
                    />
                </div>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>KvK</TableHeaderCell>
                            <TableHeaderCell>Handelsnaam</TableHeaderCell>
                            <TableHeaderCell>LH</TableHeaderCell>
                            <TableHeaderCell>Adres</TableHeaderCell>
                            <TableHeaderCell>Postcode</TableHeaderCell>
                            <TableHeaderCell textAlign='right'>
                                Plaats
                            </TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {results?.map((company, i) => (
                            <TableRow key={i} onClick={() => onChange(company)}>
                                <TableCell>{company.kvk_number}</TableCell>
                                <TableCell>{company.company}</TableCell>
                                <TableCell>{company.lh}</TableCell>
                                <TableCell>{company.street}</TableCell>
                                <TableCell>{company.zipcode}</TableCell>
                                <TableCell textAlign='right'>
                                    {company.city}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </ModalContent>
            <ModalActions>
                <Button type='button' onClick={onClose}>
                    Annuleren
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default KVKSearchModal;
